/* "You may also like" (sections/clx-related.liquid)
   1. Loads Shopify recommendations through the Section Rendering API when the section
      carries data-url (no products picked manually); hides the section if none come back.
   2. Quick add, same flow as the homepage cards: products with a choice (recipe, colour)
      open a chooser with nothing preselected; adding goes through AJAX and opens the
      theme's cart notification / drawer. Event delegation, so loaded cards work too. */
(function () {
  'use strict';
  if (window.clxRelatedReady) return;
  window.clxRelatedReady = true;

  /* ── 1. Recommendations ── */
  function load(root) {
    var url = root.getAttribute('data-url');
    if (!url || root.dataset.relLoading) return;
    root.dataset.relLoading = '1';
    fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var box = doc.querySelector('.clx-rel__box');
        var target = root.querySelector('.clx-rel__box');
        if (box && target && box.querySelector('.clx-rel__card')) {
          target.innerHTML = box.innerHTML;
          root.classList.add('is-loaded');
        } else {
          var host = root.closest('.shopify-section');
          if (host) host.hidden = true;
        }
      })
      .catch(function () {});
  }

  function initLoad() {
    document.querySelectorAll('[data-clx-rel][data-url]').forEach(function (root) {
      if (!('IntersectionObserver' in window)) { load(root); return; }
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { io.disconnect(); load(root); }
      }, { rootMargin: '0px 0px 600px 0px' });
      io.observe(root);
    });
  }

  /* ── 2. Quick add ── */
  function closeAll(except) {
    document.querySelectorAll('.clx-rel__choice:not([hidden])').forEach(function (panel) {
      if (panel !== except) close(panel, false);
    });
  }

  function open(btn) {
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    closeAll(panel);
    panel.hidden = false;
    btn.setAttribute('aria-expanded', 'true');
    var first = panel.querySelector('.clx-rel__choice-btn:not([disabled])');
    if (first) first.focus({ preventScroll: true });
  }

  function close(panel, returnFocus) {
    panel.hidden = true;
    var opener = document.querySelector('[aria-controls="' + panel.id + '"]');
    if (opener) {
      opener.setAttribute('aria-expanded', 'false');
      if (returnFocus) opener.focus({ preventScroll: true });
    }
  }

  function message(card, text, isError) {
    var msg = card.querySelector('.clx-rel__msg');
    if (!msg) return;
    msg.textContent = text;
    msg.classList.toggle('clx-rel__msg--error', !!isError);
    if (!isError) setTimeout(function () { if (msg.textContent === text) msg.textContent = ''; }, 3000);
  }

  function add(variantId, trigger) {
    var root = trigger.closest('[data-clx-rel]');
    var card = trigger.closest('.clx-rel__card');
    var atc = card.querySelector('.clx-rel__atc');
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var body = new FormData();
    body.append('id', variantId);
    body.append('quantity', '1');
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
      body.append('sections_url', window.location.pathname);
      cart.setActiveElement(atc || trigger);
    }
    trigger.setAttribute('aria-busy', 'true');
    if (atc) atc.setAttribute('aria-busy', 'true');
    message(card, root.dataset.adding, false);

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: body
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) { message(card, data.description || data.message || root.dataset.error, true); return; }
        var panel = card.querySelector('.clx-rel__choice');
        if (panel && !panel.hidden) close(panel, false);
        message(card, root.dataset.added, false);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'clx-related', productVariantId: variantId, cartData: data });
        }
        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(data);
        } else {
          window.location = window.routes.cart_url;
        }
      })
      .catch(function () { message(card, root.dataset.error, true); })
      .finally(function () {
        trigger.removeAttribute('aria-busy');
        if (atc) atc.removeAttribute('aria-busy');
      });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.clx-rel__card')) { closeAll(null); return; }
    var openBtn = e.target.closest('[data-rel-open]');
    if (openBtn) {
      var panel = document.getElementById(openBtn.getAttribute('aria-controls'));
      if (panel && !panel.hidden) { close(panel, false); } else { open(openBtn); }
      return;
    }
    var closeBtn = e.target.closest('[data-rel-close]');
    if (closeBtn) { close(closeBtn.closest('.clx-rel__choice'), true); return; }
    var addBtn = e.target.closest('[data-rel-add]');
    if (addBtn && !addBtn.disabled && !addBtn.getAttribute('aria-busy')) {
      add(addBtn.getAttribute('data-rel-add'), addBtn);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var panel = e.target.closest && e.target.closest('.clx-rel__choice');
    if (panel) close(panel, true);
  });

  if (document.readyState !== 'loading') { initLoad(); } else { document.addEventListener('DOMContentLoaded', initLoad); }
})();
